import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { DatePicker, FilePicker, Input } from "stories";
// import {useToast} from "utils/customHooks/useToast";
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ProposedProjectController } from "services/proposedProject/controller";
import { useAccordionWizard } from "stories";
import { AccordionForm } from "stories/components/accordionForm";
import { currencyRules } from "utils/customHooks/currencyFormat";
import { useFileUpload } from "utils/customHooks/useFileUpload";
import { useToast } from "utils/customHooks/useToast";
import { removeEmptyValues } from "../../../loanDetails/elements/borrower/LoanDetailsBorrower";

const proposedProjectController = ProposedProjectController();

const getAcquisitionDetailsModel = () => ({
  acquisition_amount: null,
  acquisition_closing_date: null,
  purchase_and_sale_agreement_filename: null,
  statement_of_adjustments_filename: null,
});
const AcquisitionQueryKey = "acquisition";
const Acquisition = () => {
  const form = useForm({
    defaultValues: getAcquisitionDetailsModel(),
  });
  const {
    setValue,
    control,
    formState: { errors },
  } = form;
  const params = useParams();
  const { showToast } = useToast();
  const queryClient = useQueryClient();
  const { next } = useAccordionWizard();
  const { handleFileFields } = useFileUpload();
  const queryKey = [AcquisitionQueryKey, { id: params.id }];
  const handleUpdate = async (values) => {
    values.opportunityId = params.id;
    return handleFileFields(values).then((values) => {
      values = removeEmptyValues(values);
      return proposedProjectController.updateSecuredPropertyDetails(values);
    });
  };

  const { mutate, isLoading: postLoading } = useMutation(handleUpdate, {
    onSuccess: () => {
      showToast("Secured property acquisition details updated!", "success");
      next();
      queryClient.invalidateQueries(queryKey);
    },
  });

  const { isLoading: fetchLoading } = useQuery({
    queryKey,
    queryFn: proposedProjectController.getSecuredPropertyDetails.bind(
      null,
      params.id
    ),
    onSuccess: (data) => {
      for (const key in data) {
        setValue(key, data[key]);
      }
    },
  });

  return (
    <AccordionForm
      accordionKey="acquisition"
      accordionTitle="Secured Property Acquisition Details"
      form={form}
      isPostLoading={postLoading}
      isPreLoading={fetchLoading}
      onSubmit={mutate}
    >
      <Row>
        <Col xs={4}>
          <Controller
            control={control}
            name={`acquisition_closing_date`}
            render={({ field }) => {
              return <DatePicker label={"Completion Date"} {...field} />;
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <Controller
            name="acquisition_amount"
            control={control}
            rules={currencyRules}
            render={({ field }) => {
              return (
                <Input
                  label={"Acquisition Amount"}
                  type="currency"
                  // TODO: this field is set as int in the api
                  decimalsLimit={0}
                  startAdornment="$"
                  step="0.01"
                  {...field}
                  value={field.value || ""}
                  error={errors?.acquisition_amount?.message}
                />
              );
            }}
          />
        </Col>
      </Row>
      <div className="section-title">Acquisition Documentation</div>
      <Row>
        <Col xs={6}>
          <Controller
            control={control}
            name={`purchase_and_sale_agreement_filename`}
            render={({ field }) => (
              <FilePicker
                multiple={false}
                type="file"
                label={"Purchase & Sale Agreement "}
                {...field}
              />
            )}
          />
        </Col>
        <Col xs={6}>
          <Controller
            control={control}
            name={`statement_of_adjustments_filename`}
            render={({ field }) => (
              <FilePicker
                multiple={false}
                type="file"
                label={"Statement of Adjustments"}
                {...field}
              />
            )}
          />
        </Col>
      </Row>
    </AccordionForm>
  );
};

export default Acquisition;
